import { useEffect, useState } from 'react';
import { hifenUrl, usaHifenLiteral } from './hifenUrl';

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState<any>({
        width: undefined,
        height: undefined,
    });

    function handleResize() {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize);

            handleResize();

            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);
    return windowSize;
}

export function validationHTML(value: string) {
    return /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(
        value
    );
}

export function toPrice(price: number, scale?: number | 2): string {
    return String(((price * 100) / 100).toFixed(scale))
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export function marca_dagua(mainImageSrc: string, site: any, tamanho: string,vazio?: boolean): string {
    if(!mainImageSrc)
        return mainImageSrc;
    if(mainImageSrc.toLowerCase().includes('https://fotos.sobressai.com.br/')){ 
        const fim_url = mainImageSrc.replace('http://fotos.sobressai.com.br/','').replace('https://fotos.sobressai.com.br/','').toLowerCase();
        return `https://imobtotal1.b-cdn.net/img/2/${site?.id}/${site?.marca_dagua?.posicao || "MM"}/${vazio ? 0 : site?.marca_dagua?.tamanho_marca || 15}/${vazio ? 0 : site?.marca_dagua?.opacidade || 100}/${tamanho}/${fim_url}?v=${site?.contador_marca || 0}&lv=${site?.contador_marca || 0}`;
    } else {
        if(mainImageSrc.includes('fotos2.fra1.cdn.digitaloceanspaces.com') || mainImageSrc.includes('fotos2.fra1.digitaloceanspaces.com')){ 
            const fim_url = mainImageSrc.replace('https://fotos2.fra1.cdn.digitaloceanspaces.com/','').replace('https://fotos2.fra1.digitaloceanspaces.com/','');
            return `https://imobtotal1.b-cdn.net/img/1/${site?.id}/${site?.marca_dagua?.posicao || "MM"}/${vazio ? 0 : site?.marca_dagua?.tamanho_marca || 15}/${vazio ? 0 : site?.marca_dagua?.opacidade || 100}/${tamanho}/${fim_url}?v=${site?.contador_marca || 0}&lv=${site?.contador_marca || 0}`;
        } else {
            const fim_url = mainImageSrc.replace('http://','').replace('https://','').split('?')[0];
            return `https://imobtotal1.b-cdn.net/img/3/${site?.id}/${site?.marca_dagua?.posicao || "MM"}/${vazio ? 0 : site?.marca_dagua?.tamanho_marca || 15}/${vazio ? 0 : site?.marca_dagua?.opacidade || 100}/${tamanho}/${fim_url}?v=${site?.contador_marca || 0}&lv=${site?.contador_marca || 0}`;
        }
    }
}

export function marca_dagua1(mainImageSrc: string, site: any, tamanho: string,vazio?: boolean,contador?: number): string {
    if(!mainImageSrc)
        return mainImageSrc;
    if(mainImageSrc.toLowerCase().includes('https://fotos.sobressai.com.br/')){ 
        const fim_url = mainImageSrc.replace('http://fotos.sobressai.com.br/','').replace('https://fotos.sobressai.com.br/','').toLowerCase();
        return `https://imobtotal1.b-cdn.net/img/2/${site?.id}/${site?.marca_dagua?.posicao || "MM"}/${vazio ? 0 : site?.marca_dagua?.tamanho_marca || 15}/${vazio ? 0 : site?.marca_dagua?.opacidade || 100}/${tamanho}/${fim_url}?v=${contador || 0}&lv=${contador || 0}`;
    } else {
        if(mainImageSrc.includes('fotos2.fra1.cdn.digitaloceanspaces.com') || mainImageSrc.includes('fotos2.fra1.digitaloceanspaces.com')){ 
            const fim_url = mainImageSrc.replace('https://fotos2.fra1.cdn.digitaloceanspaces.com/','').replace('https://fotos2.fra1.digitaloceanspaces.com/','');
            return `https://imobtotal1.b-cdn.net/img/1/${site?.id}/${site?.marca_dagua?.posicao || "MM"}/${vazio ? 0 : site?.marca_dagua?.tamanho_marca || 15}/${vazio ? 0 : site?.marca_dagua?.opacidade || 100}/${tamanho}/${fim_url}?v=${contador || 0}&lv=${contador || 0}`;
        } else {
            const fim_url = mainImageSrc.replace('http://','').replace('https://','').split('?')[0];
            return `https://imobtotal1.b-cdn.net/img/3/${site?.id}/${site?.marca_dagua?.posicao || "MM"}/${vazio ? 0 : site?.marca_dagua?.tamanho_marca || 15}/${vazio ? 0 : site?.marca_dagua?.opacidade || 100}/${tamanho}/${fim_url}?v=${contador || 0}&lv=${contador || 0}`;
        }
    }
}

export function formatDate(timestamp: string | number): string {
    if (!timestamp) return '';

    let date: Date;

    try {
        const parsed = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
        if (isNaN(parsed)) return '';

        date = new Date(parsed);
        if (isNaN(date.getTime())) return '';
    } catch {
        return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // meses são 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

// Versão ISO 8601 (yyyy-mm-dd) do formatDate, para datas em JSON-LD/schema.org
// (datePublished/dateModified). O formato dd/mm/yyyy do formatDate é só para exibição.
export function formatDateIso(timestamp: string | number): string {
    if (!timestamp) return '';
    try {
        const parsed = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
        if (isNaN(parsed)) return '';
        const date = new Date(parsed);
        if (isNaN(date.getTime())) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    } catch {
        return '';
    }
}

export function apenasNumeros(value: any) {
    if(value){
        let array = value.split(',');
        const arrayImoveis = array.map((x: any) => {
            return Number(x)
        })
        return arrayImoveis;
    }else{
        return [];
    }
}

// #1117: caminho da lista de FAVORITOS — sem transação no caminho. Antes cada ponto de entrada
// (compartilhar, menu, rodapé) montava `/imoveis/<1ª transação do tenant>/-/-/-/-?favoritos=...`,
// e num site que começa por Venda o próprio link filtrava fora os favoritos de aluguel/temporada:
// quem recebia a seleção abria a página vazia. A seleção do visitante é o recorte; a rota curta
// `/imoveis` é neutra e vale para qualquer combinação de transações.
export function favoritosHref(favorito: any, codsite?: any) {
    const ids = Array.isArray(favorito) ? favorito.join(',') : favorito;
    return `/imoveis?favoritos=${ids}${codsite ? '&codsite=' + codsite : ''}`;
}

export function arrumaData(value: any) {
    if (!value) return "";
    const split = String(value).split('-');
    if(split[0]?.length == 4){
        return split[2]+"/"+split[1]+"/"+split[0];
    }else{
        return value?.replaceAll("-","/");
    }
}

export function montaLinks(allRodape: any) {
    let links: { url: string; title: string; contador: number; }[] = []; // Array para armazenar os links
    let cont = 0;
    let total = 0;
    for (let i = 0; i < allRodape.length; i++) {
        let v = allRodape[i];
        let url_completa = ''
        let title = ''
        // Constrói a URL
        switch (cont) {
            case 0:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/${v?.bairro ? v?.bairro : '-'}/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.bairro ? v?.bairro + ' - '+v?.cidade : v?.cidade}`;
                cont++;
                break;
            case 1:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/-/-/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'}`;
                cont++;
                break;
            case 2:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/-/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.cidade}`;
                cont++;
                break;
            case 3:
                if(v?.dormitorios > 0){
                    url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/-/-/-?dormitorios=${v?.dormitorios}`.replaceAll(' ','-').toLowerCase();
                    title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.dormitorios ? ' '+v?.dormitorios+' dormitórios' : ''}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.cidade}`;
                }
                cont = 0;
                break;
            default:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/${v?.bairro ? v?.bairro : '-'}/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.bairro ? v?.bairro + ' - '+v?.cidade : v?.cidade}`;
                cont = 0;
                break;
        }

        if(v?.tipo && v?.empreendimento){
            const tituloExistente1 = links.some(link => link.title === title);

            if (!tituloExistente1) {
                links.push({url: removerAcentos(`/imoveis/${v?.venda ? 'venda' : 'aluguel'}/-/-/${v?.empreendimento.replaceAll(" ","-").replaceAll("\n", '-')}/${v?.tipo}`.replaceAll(' ','-').toLowerCase()), title: `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} Empreendimento ${v?.empreendimento}`, contador: cont});
                total++;
            }
        }

        const tituloExistente = links.some(link => link.title === title);

        if (!tituloExistente && title != '') {
            // INC-0278: link interno sem acento (a listagem acentuada agora é 301 para esta)
            links.push({url: removerAcentos(url_completa), title: title, contador: cont});
            total++;
            if(total >= 20)
                break;
        }
    }

    return links;
}

export function capitalizeWords(str: string): string {
    return str.replace(/(^|[ ,\-.])\w/g, function(char) {
        return char.toUpperCase();
    });
}

/**
 * `data_entrega` → milissegundos (NaN se vazio/inválido). O site-graphql devolve ISO ("2028-08-31T00:00:00.000Z");
 * o código antigo fazia `Number(iso)` = NaN e a ficha mostrava "Data de Entrega: Invalid Date" (cs2016, 05/11).
 * Aceita também timestamp numérico (formato antigo) e "YYYY-MM-DD HH:MM:SS" do MySQL (lido como UTC).
 */
export function dataEntregaMs(valor: unknown): number {
    if (valor === null || valor === undefined || valor === '') return NaN;
    if (typeof valor === 'number') return valor;
    const s = String(valor).trim();
    if (/^-?\d+(\.\d+)?$/.test(s)) return Number(s);
    return Date.parse(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(s) ? `${s.replace(' ', 'T')}Z` : s);
}

export function formatarDataEntrega(valor: unknown): string {
    const timestamp = dataEntregaMs(valor);
    if (Number.isNaN(timestamp)) return 'false';
    const dataUTC = new Date(timestamp + new Date().getTimezoneOffset() * 60000);
    const agora = new Date();

    // Se a data estiver no passado, retorna null
    if (dataUTC < agora) {
        return 'false';
    }

    const opcoes = { month: "long", year: "numeric" } as const;
    return dataUTC.toLocaleDateString("pt-BR", opcoes);
}


// Slug ÚNICO nos sitemaps de busca (INC-0280): cada nome (cidade/bairro/empreendimento/tipo) vira segmento
// pelo MESMO normalizador dos cards, da URL canônica e do breadcrumb (slugSegmentoFiltro, com o gate de
// hífen do site). Antes era o nome cru com espaço → "-" e o formatSitemapLoc só tirava acento: "Passo d'Areia"
// saía "passo-d'areia" no sitemap e "passo-d-areia" nos cards (duas URLs da mesma busca), e "/" no nome
// abria um segmento a mais. O formatSitemapLoc segue por cima (idempotente para slug) só para escapar o XML.
const segmentoSitemap = (nome: any, site: any): string => slugSegmentoFiltro(nome, site?.id);

export function arrumaUrlTiposSiteMaps(value: any, domain: any) {
    let allUrl: Array<string> = [];
    const transacao = value?.site?.transacoes[0].toLowerCase();
    value?.tipos.map((item: any)=>{
        if(item?.nome){
            allUrl.push(domain+"/imoveis/"+transacao+"/-/-/-/"+segmentoSitemap(item?.nome, value?.site))
        }
    })
    if(value?.site?.transacoes?.length > 1){
        value?.tipos.map((item: any)=>{
            if(item?.nome){
                allUrl.push(domain+"/imoveis/"+value?.site?.transacoes[0].toLowerCase()+"/-/-/-/"+segmentoSitemap(item?.nome, value?.site))
            }
        })
    }

    return allUrl;
}

export function arrumaUrlEmpreendimentosMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];
    const transacao = value?.site?.transacoes[0].toLowerCase();
    if(value?.empreendimentos?.length > 0){
        value?.empreendimentos.map((item: any)=>{
            if(item?.nome){
                allUrl.push(domain+"/imoveis/"+transacao+"/-/-/"+segmentoSitemap(item?.nome, value?.site)+"/-")
            }
        })
        if(value?.site?.transacoes?.length > 1){
            value?.empreendimentos.map((item: any)=>{
                if(item?.nome){
                    allUrl.push(domain+"/imoveis/"+value?.site?.transacoes[1].toLowerCase()+"/-/-/"+segmentoSitemap(item?.nome, value?.site)+"/-")
                }
            })
        }
    }

    return allUrl;
}

export function arrumaUrlBairrosMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];
    const transacao = value?.site?.transacoes[0].toLowerCase();
    value?.bairros.map((item: any)=>{
        if(item?.nome && item?.cidade?.nome){
            allUrl.push(domain+"/imoveis/"+transacao+"/"+segmentoSitemap(item?.cidade?.nome, value?.site)+"/"+segmentoSitemap(item?.nome, value?.site)+"/-/-")
        }
    })
    if(value?.site?.transacoes?.length > 1){
        value?.bairros.map((item: any)=>{
            if(item?.nome && item?.cidade?.nome){
                allUrl.push(domain+"/imoveis/"+value?.site?.transacoes[1].toLowerCase()+"/"+segmentoSitemap(item?.cidade?.nome, value?.site)+"/"+segmentoSitemap(item?.nome, value?.site)+"/-/-")
            }
        })
    }
    return allUrl;
}

// Regex de caracteres de controle (espelha CONTROL_CHAR_PATTERN de lib/server/site-props).
const IMOVEL_CONTROL_CHARS = new RegExp(
    `[${String.fromCharCode(0)}-${String.fromCharCode(31)}${String.fromCharCode(127)}]+`,
    'g'
);

// Slug de um segmento da URL do imóvel. FONTE ÚNICA da regra de slug, compartilhada
// entre o redirect 301 (/imovel/[id]), a tag <link rel="canonical"> e o sitemap.
// Hífens literais do nome viram "002d" para round-trip correto no parser de busca
// (ex.: "Xangri-lá" -> "xangri002dla", e não "xangri-la"). `hifenLiteral` (gate utils/hifenUrl,
// cs2588) mantém o hífen: "Xangri-lá" -> "xangri-la".
export function sanitizeImovelSegment(value: any, hifenLiteral = false): string {
    const raw = String(value || '')
        .replace(IMOVEL_CONTROL_CHARS, ' ')
        .trim();
    if (!raw) return '-';

    const normalized = removerAcentos(raw)
        .replace(IMOVEL_CONTROL_CHARS, ' ')
        .replace(/-/g, hifenLiteral ? '-' : '002D')
        .replace(/[/.]+/g, ' ')
        .replace(/[^a-zA-Z0-9\s]/g, ' ')
        .replace(/\s+/g, '-')
        .toLowerCase()
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');

    return normalized || '-';
}

// Slug de um segmento de FILTRO da listagem (/imoveis/{model}/{city}/{district}/{company}/{type}).
// É de propósito a MESMA regra do slug do imóvel: a IDA (o formulário e os links que MONTAM a
// URL) e a VOLTA (o lookup que reconstrói o filtro a partir da URL) precisam falar a mesma
// língua. Enquanto não falavam, nome com "/" — "Galpão / Barracão", "Escritório/Sala" — virava
// um segmento que nenhum lookup reconhecia (e a barra ainda estourava um segmento a mais na
// rota), então o filtro era DESCARTADO em silêncio e a busca devolvia a lista inteira.
export function slugSegmentoFiltro(value: any, codsite?: unknown): string {
    return sanitizeImovelSegment(value, usaHifenLiteral(codsite));
}

// Chave de comparação de um segmento CRU vindo da URL. Ele pode chegar percent-encoded, com
// maiúsculas, com espaço ou com hífens repetidos — normaliza tudo isso SEM tentar reconstruir
// o nome original (o caminho de volta que perdia a barra). Idempotente para segmento já em slug.
export function chaveSegmentoFiltro(seg: any): string {
    let bruto = String(seg ?? '');
    try {
        bruto = decodeURIComponent(bruto);
    } catch {
        // segmento com '%' solto: compara como veio
    }

    return removerAcentos(bruto)
        .replace(IMOVEL_CONTROL_CHARS, ' ')
        .replace(/\s+/g, '-')
        .toLowerCase()
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
}

// O segmento da URL corresponde a este nome (tipo/bairro/cidade/empreendimento)?
// No gate de hífen literal (utils/hifenUrl) casa também "xangri-la" — e o "xangri002dla" de
// link antigo continua casando.
export function segmentoFiltroCasaNome(seg: any, nome: any, codsite?: unknown): boolean {
    const chave = chaveSegmentoFiltro(seg);
    if (!chave || chave === '-') return false;

    return chave === slugSegmentoFiltro(nome) || (usaHifenLiteral(codsite) && chave === slugSegmentoFiltro(nome, codsite));
}

// Caracteres que QUEBRAM um segmento de caminho cru: "/" abre um segmento a mais na rota, "?"
// e "#" cortam o caminho (viram query/âncora), "%" estraga o decodeURIComponent, "\" vira "/"
// em alguns navegadores e "+" é o separador da seleção múltipla da listagem.
const RESERVADOS_SEGMENTO_URL = /[\/?#%\\+]/;

// Segmento SEGURO de filtro (cidade/bairro/tipo) para MONTAR a URL da listagem na busca por IA
// (INC-0018 F4). Nome sem caractere reservado sai no formato de sempre — o link fica idêntico
// ao de hoje. Nome COM caractere reservado ("Residential / Sobrado") sai pelo slug canônico
// `slugSegmentoFiltro`, que é exatamente o que `segmentoFiltroCasaNome` usa para CASAR o
// segmento de volta com o nome na listagem: a ida e a volta usam a mesma régua.
export function segmentoFiltroSeguro(label: any, codsite?: unknown): string {
    const bruto = String(label ?? '').trim();
    if (!bruto) return '';
    if (RESERVADOS_SEGMENTO_URL.test(bruto)) {
        const slug = slugSegmentoFiltro(bruto, codsite);
        return slug === '-' ? '' : slug;
    }
    return removerAcentos(hifenUrl(bruto, codsite).replaceAll('\n', '-').replaceAll(' ', '-'))
        .toLowerCase()
        .replaceAll(' ', '');
}

// Caminho canônico ÚNICO de um imóvel: /imoveis/{model}/{city}/{district}/{company}/{type}/{code}/imovel/{id}
// Usado por:
//   - o redirect 301 da rota curta /imovel/[id] (lib/server/site-props: buildImovelCanonicalPath delega aqui)
//   - a tag <link rel="canonical"> da página    (utils/ImovelHead)
//   - o sitemap all_imoveis.xml                  (arrumaUrlImoveisSiteMaps)
// Mantê-los idênticos evita que o Google veja URLs duplicadas concorrentes (causa das
// páginas "não indexadas" no Search Console). O segmento de empreendimento só aparece
// quando o site exibe empreendimento (igual ao comportamento server-side).
export function montaUrlImovelCanonica(imovel: any, site: any): string {
    const model = imovel?.venda
        ? 'venda'
        : imovel?.aluguel
        ? 'aluguel'
        : imovel?.temporada
        ? 'temporada'
        : 'venda';
    const hifen = usaHifenLiteral(site?.id);
    const city = sanitizeImovelSegment(imovel?.cidade?.nome, hifen);
    const district = sanitizeImovelSegment(imovel?.bairro?.nome, hifen);
    const hideCompanyInUrl = Number(site?.id) === 2551;
    const company = site?.exibir_empreendimento && !hideCompanyInUrl
        ? sanitizeImovelSegment(imovel?.empreendimento?.nome, hifen)
        : '-';
    const type = sanitizeImovelSegment(imovel?.tipo?.nome, hifen);
    const code = sanitizeImovelSegment(imovel?.referencia, hifen);
    const id = Number(String(imovel?.id ?? '').replace(/[^\d]/g, '')) || 0;

    return `/imoveis/${model}/${city}/${district}/${company}/${type}/${code}/imovel/${id}`;
}

// Breadcrumb (HistoryComponent) no gate de hífen literal (utils/hifenUrl): o rótulo sai do
// segmento da URL e "xangri-la" viraria "Xangri la" — aqui o segmento aponta para o nome real
// ("Xangri-lá"), inclusive o "xangri002dla" de link antigo. Só nomes com hífen; fora do gate,
// vazio (o breadcrumb segue como sempre).
export function rotulosHifen(nomes: any[], codsite: unknown): Record<string, string> {
    const rotulos: Record<string, string> = {};
    if (!usaHifenLiteral(codsite)) return rotulos;
    nomes.forEach((nome) => {
        const limpo = String(nome ?? '').trim();
        if (!limpo.includes('-')) return;
        rotulos[sanitizeImovelSegment(limpo, true)] = limpo;
        rotulos[sanitizeImovelSegment(limpo)] = limpo;
    });
    return rotulos;
}

// Ficha do imóvel: os segmentos da URL são os nomes do próprio imóvel.
export function rotulosHifenBreadcrumb(imovel: any, site: any): Record<string, string> {
    return rotulosHifen(
        [imovel?.cidade?.nome, imovel?.bairro?.nome, imovel?.empreendimento?.nome, imovel?.tipo?.nome, imovel?.referencia],
        site?.id
    );
}

export function arrumaUrlImoveisSiteMaps(value: any, domain: any) {
    let allUrl: Array<string> = [];
    let allUrl_fotos: Array<string> = [];
    const site = value?.site;
    if(value?.imoveis?.imoveis?.length > 0){
        value?.imoveis?.imoveis.map((item: any)=>{
            // Mesma URL canônica do redirect 301 e da tag canonical da página,
            // para que sitemap, canonical e redirect apontem para a mesma URL.
            allUrl.push(domain + montaUrlImovelCanonica(item, site))
            allUrl_fotos.push(item?.fotos?.[0]?.url_foto)
        })
    }

    return [allUrl,allUrl_fotos];
}

// Gera as URLs de BUSCA de imóveis (páginas de listagem filtrada), usando a mesma
// query/dados do all_imoveis.xml. Para cada imóvel, em vez da URL do imóvel, cria
// todas as combinações possíveis de filtro por cidade/bairro/tipo, ex.:
//   /imoveis/venda/caxias-do-sul/exposicao/-/cobertura
//   /imoveis/venda/caxias-do-sul/-/-/-
//   /imoveis/venda/-/-/-/cobertura  ...
// O segmento de empreendimento (company) fica sempre "-", igual à URL do imóvel.
// A combinação base (-/-/-) é omitida pois já existe em all_sites.xml.
// As URLs são deduplicadas, pois vários imóveis compartilham cidade/bairro/tipo.
export function arrumaUrlBuscasImoveisSiteMaps(value: any, domain: any) {
    const urlsSet = new Set<string>();

    if (value?.imoveis?.imoveis?.length > 0) {
        value?.imoveis?.imoveis.forEach((item: any) => {
            const model = item?.venda ? 'venda' : item?.aluguel ? 'aluguel' : 'temporada';
            const city = segmentoSitemap(item?.cidade?.nome, value?.site);
            const district = segmentoSitemap(item?.bairro?.nome, value?.site);
            const type = segmentoSitemap(item?.tipo?.nome, value?.site);

            const hasCity = city !== '-';
            const hasDistrict = district !== '-';
            const hasType = type !== '-';

            // Bairro sem cidade só entra quando o imóvel não tem cidade: com cidade, a URL
            // "-/<bairro>" é a MESMA busca de "<cidade>/<bairro>" (a listagem redireciona uma
            // para a outra) e o Google via as duas como canônicas (INC-0079 cs2451: 992 de 2.167).
            const combos: Array<[string, string, string]> = [];
            if (hasCity) combos.push([city, '-', '-']);
            if (hasDistrict && !hasCity) combos.push(['-', district, '-']);
            if (hasType) combos.push(['-', '-', type]);
            if (hasCity && hasDistrict) combos.push([city, district, '-']);
            if (hasCity && hasType) combos.push([city, '-', type]);
            if (hasDistrict && hasType && !hasCity) combos.push(['-', district, type]);
            if (hasCity && hasDistrict && hasType) combos.push([city, district, type]);

            combos.forEach(([c, d, t]) => {
                urlsSet.add(domain + '/imoveis/' + model + '/' + c + '/' + d + '/-/' + t);
            });
        });
    }

    return Array.from(urlsSet);
}

// INC-0364 (cs2409, 04/11/2026): all_cidades.xml, all_bairros.xml e all_tipos.xml passam a derivar dos
// IMÓVEIS publicados (mesmo dataset do all_buscas_imoveis.xml), não do cadastro de cidades/bairros/tipos.
// O cadastro cruzava TODO bairro/tipo com TODAS as transações do site, e a combinação sem imóvel
// (ex.: bairro só com venda listado também em aluguel) virava página vazia → soft 404 no Search
// Console (11 URLs do all_bairros.xml do cs2409). Aqui cada URL nasce de pelo menos 1 imóvel, e
// um imóvel venda+aluguel conta nas duas transações.
export function arrumaUrlBuscasPorNivelSiteMaps(value: any, domain: any, nivel: 'cidade' | 'bairro' | 'tipo') {
    const urlsSet = new Set<string>();

    (value?.imoveis?.imoveis || []).forEach((item: any) => {
        const models: string[] = [];
        if (item?.venda) models.push('venda');
        if (item?.aluguel) models.push('aluguel');
        if (item?.temporada) models.push('temporada');
        if (models.length === 0) return;

        const city = segmentoSitemap(item?.cidade?.nome, value?.site);
        const district = segmentoSitemap(item?.bairro?.nome, value?.site);
        const type = segmentoSitemap(item?.tipo?.nome, value?.site);

        let combo: [string, string, string] | null = null;
        if (nivel === 'cidade' && city !== '-') combo = [city, '-', '-'];
        if (nivel === 'bairro' && city !== '-' && district !== '-') combo = [city, district, '-'];
        if (nivel === 'tipo' && type !== '-') combo = ['-', '-', type];
        if (!combo) return;

        const [c, d, t] = combo;
        models.forEach((model) => {
            urlsSet.add(domain + '/imoveis/' + model + '/' + c + '/' + d + '/-/' + t);
        });
    });

    return Array.from(urlsSet);
}

export function arrumaUrlSitesMaps(value: any, dominio?: any) {
    let allUrl: Array<string> = [];
    allUrl.push(dominio)
    if(value?.site?.exibir_empreendimento){
        allUrl.push(dominio+"/condominios")
    }
    value?.site?.transacoes.map((item: any)=>{
        // Apenas a forma canônica de 6 segmentos. A forma curta (/imoveis/{transacao})
        // serve o mesmo conteúdo e era duplicata — agora a página de busca canonicaliza
        // qualquer profundidade para esta forma (ver RenderImoveisDetails em pages/_app).
        allUrl.push((dominio+"/imoveis/"+item.toLowerCase()+"/-/-/-/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
    })
    return allUrl;
}

export function arrumaUrlCidadesMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];

    const transacao = value?.site?.transacoes[0].toLowerCase();
    value?.cidades.map((item: any)=>{
        if(item?.nome){
            allUrl.push(domain+"/imoveis/"+transacao+"/"+segmentoSitemap(item?.nome, value?.site)+"/-/-/-")
        }
    })
    if(value?.site?.transacoes?.length > 1){
        value?.cidades.map((item: any)=>{
            if(item?.nome){
                allUrl.push(domain+"/imoveis/"+value?.site?.transacoes[1].toLowerCase()+"/"+segmentoSitemap(item?.nome, value?.site)+"/-/-/-")
            }
        })
    }

    return allUrl;
}

export function arrumaUrlBlogsMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];

    value?.blogsBusca.map((item: any)=>{
        if(item?.id){
            allUrl.push(domain+"/blog/"+item?.id)
        }
    })

    return allUrl;
}

export function apenasArray(value: any) {
    return JSON.stringify(value).replaceAll(/[^0-9\,]/g,'');
}

export function formatAutomaticPropertyRooms(
    detailsProperties: any,
    site: any,
    singular = 'quarto',
    plural = 'quartos'
): string {
    const bedrooms = Number(detailsProperties?.dormitorios || 0);
    const suites = Number(detailsProperties?.suites || 0);

    if (Number(site?.id) === 2504 && bedrooms > 0 && suites > 0) {
        return `${bedrooms} ${bedrooms === 1 ? singular : plural} (sendo ${suites} ${suites === 1 ? 'suíte' : 'suítes'}) `;
    }

    const bedroomsText = bedrooms > 0
        ? `${bedrooms} ${bedrooms === 1 ? singular : plural} `
        : '';
    const suitesText = suites > 0
        ? `e ${suites} ${suites === 1 ? 'suíte' : 'suítes'} `
        : '';

    return bedroomsText + suitesText;
}

export function gera_titulo(detailsProperties: any,site: any): any {

    const titulo = `${detailsProperties?.empreendimento?.nome && site?.exibir_empreendimento ? detailsProperties?.empreendimento?.nome+" - " : ''}${detailsProperties?.tipo?.nome}
    ${detailsProperties?.area_privativa > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_privativa)) +" "+ detailsProperties?.area_tipo + " privativos, " :
    detailsProperties?.area_total > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_total)) +" "+ detailsProperties?.area_tipo + " de área total, " :
    detailsProperties?.terreno > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.terreno)) +" "+ detailsProperties?.area_tipo + " de área terreno, " : ""}
    ${formatAutomaticPropertyRooms(detailsProperties, site, 'dormitório', 'dormitórios')}
    ${"em "+detailsProperties?.cidade?.nome}`

    return titulo
}

export function MaskPhone(v: string): string {
    let valueInitial = v?.replace(/\D/g, '').replace(/^0/, '') || '';
    if (valueInitial.length >= 11) {
        valueInitial = valueInitial.replace(
            /^(\d\d)(\d{5})(\d{4}).*/,
            '($1) $2-$3'
        );
    } else if (valueInitial.length == 10) {
        valueInitial = valueInitial.replace(
            /^(\d\d)(\d{4})(\d{0,4}).*/,
            '($1) $2-$3'
        );
    } else if (valueInitial.length > 7) {
        valueInitial = valueInitial.replace(
            /^(\d\d)(\d{4})(\d{0,4}).*/,
            '($1) $2-$3'
        );
    } else if (valueInitial.length > 2) {
        valueInitial = valueInitial.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
    } else if (v?.trim() !== '') {
        valueInitial = valueInitial.replace(/^(\d*)/, '($1');
    }
    return valueInitial;
}

export function removerAcentos(str: string) {
    const source = String(str ?? '');
    if (typeof source.normalize !== 'function') return source;

    // Usa NFKD para decompor acentos espaçadores (ex.: U+00B4) que não se separam em NFD
    // e remove tanto diacríticos combinantes quanto acentos isolados comuns.
    return source
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[\u00B4`^~¨\u02C6\u02CB\u02CA]/g, '');
}

export function escapeXml(value: any): string {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}

export function formatSitemapLoc(value: any): string {
    return escapeXml(removerAcentos(value).toLowerCase());
}

export function gerarSlug(str: string): string {
  return str
    .normalize('NFD')                      // Remove acentos
    .replace(/[\u0300-\u036f]/g, '')       // Remove marcações de acento
    .toLowerCase()                         // Tudo minúsculo
    .replace(/[^a-z0-9\s-]/g, '')          // Remove tudo que não é letra, número, espaço ou hífen
    .replace(/\s+/g, '-')                  // Troca espaços por hífen
    .replace(/-+/g, '-')                   // Troca múltiplos hífens por um só
    .replace(/^-+|-+$/g, '');              // Remove hífens do início/fim
}

interface Cidade {
  label: string;
  id: number;
}

import { decode } from 'html-entities'; // npm i html-entities
export function linkifyCidades(textoHtml: string, cidades: Cidade[]): string {
    if (!textoHtml || cidades.length === 0) return textoHtml;

    // 1) converte "&aacute;" → "á", etc.
    const textoDecodado = decode(textoHtml);

    // 2) monta o padrão usando Unicode property escapes
    const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const nomes = cidades.map(c => escape(c.label)).join('|');
    const cidadesRegex = new RegExp(`(?<!\\p{L})(${nomes})(?!\\p{L})`, 'giu');

    // 3) substitui por link
    const textoLinkado = textoDecodado.replace(cidadesRegex, match => {
        const slug = encodeURIComponent(match);        // ou sua função slugify
        return `<a title="Imóveis à venda em ${match}" 
                href="/imoveis/venda/${slug}/-/-/-" data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch     
                                rel="nofollow">${match}</a>`;
    });

    return textoLinkado;
}

export function linkifyCidadesSafe(textoHtml: string, cidades: Cidade[]): string {
    if (!textoHtml || !Array.isArray(cidades) || cidades.length === 0) return textoHtml;

    const escape = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const nomes = cidades
        .map((cidade) => cidade?.label?.trim())
        .filter((cidade): cidade is string => Boolean(cidade))
        .sort((a, b) => b.length - a.length)
        .map(escape);

    if (nomes.length === 0) return textoHtml;

    const cidadesRegex = new RegExp(`(?<!\\p{L})(${nomes.join('|')})(?!\\p{L})`, 'giu');
    const partes = textoHtml.split(/(<[^>]+>)/g);
    let anchorDepth = 0;

    return partes
        .map((parte) => {
            if (!parte) return parte;

            if (parte.startsWith('<')) {
                if (/^<\/a\b/i.test(parte)) {
                    anchorDepth = Math.max(0, anchorDepth - 1);
                    return parte;
                }

                if (/^<a\b/i.test(parte) && !/\/>$/.test(parte)) {
                    anchorDepth += 1;
                }

                return parte;
            }

            if (anchorDepth > 0) return parte;

            return decode(parte).replace(cidadesRegex, (match) => {
                const slug = encodeURIComponent(match);
                return `<a title="Imóveis à venda em ${match}" href="/imoveis/venda/${slug}/-/-/-" data-no-quicklink data-no-instant data-no-prefetch rel="nofollow">${match}</a>`;
            });
        })
        .join('');
}

export function completarURL(url: string): string {
    const numBarras = (url.match(/\//g) || []).length; // Conta o número de ocorrências de '/' na string
    const barrasFaltando = 6 - numBarras; // Calcula quantas barras faltam

    if (barrasFaltando > 0) {
        return url + '/-'.repeat(barrasFaltando); // Adiciona '/' até completar 6
    } else {
        return url; // Retorna a URL original se já tiver 6 ou mais '/'
    }
}

export function hexToRgba(hex: string, alpha = 1) {
  // A cor vem do tenant e pode ser NULL (coluna CorSite* vazia no banco). Sem esta guarda um
  // único `null.replace` estourava no SSR e derrubava a PÁGINA INTEIRA com 500 — foi o que
  // tirou a listagem do cs2602 do ar (cor13 nula + cor5 escura). Cor inválida agora degrada
  // pro preto translúcido (todos os usos são borda/fundo/texto com alpha), nunca quebra.
  let value = typeof hex === 'string' ? hex.trim().replace('#', '') : '';
  if (value.length === 3) {
    value = value.split('').map(x => x + x).join('');
  }
  const r = parseInt(value.substring(0,2), 16);
  const g = parseInt(value.substring(2,4), 16);
  const b = parseInt(value.substring(4,6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return `rgba(0, 0, 0, ${alpha})`;
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function formatCaracteristicas(caracteristicas: any[]): any {
    return caracteristicas.flatMap(caracteristica => {
      const { id, nome, imovel, condominio } = caracteristica;

      const formattedCaracteristicas = [];

      // Se for um item de condomínio
      if (condominio) {
        formattedCaracteristicas.push({
          label: `${nome} - condomínio`,
          value:  id
        });
      } else {
        formattedCaracteristicas.push({
            label: `${nome} - unidade`,
            value:  id
          });
      }

      return formattedCaracteristicas;
    });
};

export function isColorLight(hexColor: any) {
  if (!hexColor) return true;
  // Remove "#" se existir
  hexColor = hexColor.replace('#', '');

  // Se for cor reduzida tipo #fff
  if (hexColor.length === 3) {
    hexColor = hexColor.split('').map((x: any) => x + x).join('');
  }

  const r = parseInt(hexColor.substr(0,2),16);
  const g = parseInt(hexColor.substr(2,2),16);
  const b = parseInt(hexColor.substr(4,2),16);

  // Fórmula padrão de luminância relativa
  const luminance = (0.299*r + 0.587*g + 0.114*b)/255;

  return luminance > 0.7; // 0 = preto, 1 = branco (ajuste o threshold se quiser)
}

type RGBColor = {
  r: number;
  g: number;
  b: number;
};

function clampChannel(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.min(255, value));
}

function parseColorToRGB(color?: string | null): RGBColor | null {
  if (!color || typeof color !== "string") return null;
  const normalized = color.trim();

  if (normalized.startsWith("#")) {
    let hex = normalized.slice(1);
    if (hex.length === 3 || hex.length === 4) {
      hex = hex
        .slice(0, 3)
        .split("")
        .map((channel) => `${channel}${channel}`)
        .join("");
    } else if (hex.length === 8) {
      hex = hex.slice(0, 6);
    }

    if (!/^[0-9a-fA-F]{6}$/.test(hex)) return null;

    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16),
    };
  }

  const rgbMatch = normalized.match(/^rgba?\((.+)\)$/i);
  if (!rgbMatch) return null;

  const valuesRaw = rgbMatch[1].split("/")[0].trim();
  const values = valuesRaw.includes(",")
    ? valuesRaw.split(",").map((item) => item.trim())
    : valuesRaw.split(/\s+/).map((item) => item.trim());

  if (values.length < 3) return null;

  const parseChannelValue = (rawValue: string): number => {
    if (rawValue.endsWith("%")) {
      return clampChannel((parseFloat(rawValue) / 100) * 255);
    }
    return clampChannel(parseFloat(rawValue));
  };

  const r = parseChannelValue(values[0]);
  const g = parseChannelValue(values[1]);
  const b = parseChannelValue(values[2]);

  if ([r, g, b].some((value) => Number.isNaN(value))) return null;

  return { r, g, b };
}

function getRelativeLuminance(color: RGBColor): number {
  const toLinear = (channel: number) => {
    const srgb = channel / 255;
    return srgb <= 0.03928
      ? srgb / 12.92
      : Math.pow((srgb + 0.055) / 1.055, 2.4);
  };

  const r = toLinear(color.r);
  const g = toLinear(color.g);
  const b = toLinear(color.b);

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function getContrastRatio(foregroundColor: string, backgroundColor: string): number {
  const foreground = parseColorToRGB(foregroundColor);
  const background = parseColorToRGB(backgroundColor);

  if (!foreground || !background) return 0;

  const foregroundLuminance = getRelativeLuminance(foreground);
  const backgroundLuminance = getRelativeLuminance(background);
  const lighter = Math.max(foregroundLuminance, backgroundLuminance);
  const darker = Math.min(foregroundLuminance, backgroundLuminance);

  return (lighter + 0.05) / (darker + 0.05);
}

export function getAccessibleTextColor(
  backgroundColor: string,
  darkColor = "#111111",
  lightColor = "#FFFFFF"
): string {
  const darkRatio = getContrastRatio(darkColor, backgroundColor);
  const lightRatio = getContrastRatio(lightColor, backgroundColor);

  if (!darkRatio && !lightRatio) {
    return isColorLight(backgroundColor) ? darkColor : lightColor;
  }

  return darkRatio >= lightRatio ? darkColor : lightColor;
}

export function ensureReadableTextColor(
  preferredColor: string | undefined,
  backgroundColor: string,
  minContrast = 4.5,
  fallbackDark = "#111111",
  fallbackLight = "#FFFFFF"
): string {
  if (preferredColor) {
    const preferredRatio = getContrastRatio(preferredColor, backgroundColor);
    if (preferredRatio >= minContrast) return preferredColor;
  }

  return getAccessibleTextColor(backgroundColor, fallbackDark, fallbackLight);
}

export function getYoutubeId(videoUrl = "") {
    let videoId = "";
    try {
        if (videoUrl.includes("v=")) {
        videoId = videoUrl.split("v=")[1].split("&")[0];
        } else {
        videoId = videoUrl.split("/").slice(-1)[0];
        }
        // Remove parâmetros extras se houver
        videoId = videoId.split("?")[0];

        // Verifica se tem 11 caracteres e é só letras/números/traço/underline
        if (/^[\w-]{11}$/.test(videoId)) {
        return videoId;
        }
        // Retorna "" se não for válido
        return "";
    } catch (e) {
        return "";
    }
}

export function ipToInt(ip: string): number {
    return ip.split('.').reduce((int, oct) => (int << 8) + parseInt(oct, 10), 0);
}

export function isIPInCIDR(ip: string, cidr: string): boolean {
    if (!cidr.includes('/')) {
        // Se não for CIDR, compara IP direto
        return ip === cidr;
    }
    const [range, bitsStr] = cidr.split('/');
    const bits = bitsStr ? parseInt(bitsStr, 10) : 32;
    const ipInt = ipToInt(ip);
    const rangeInt = ipToInt(range);
    const mask = ~(2 ** (32 - bits) - 1);

    return (ipInt & mask) === (rangeInt & mask);
}

export function isAllowedIP(ip: string, allowedCIDRs: string[]): boolean {
    return allowedCIDRs.some(cidr => isIPInCIDR(ip, cidr));
}

const PII_KEYS = ["lead_name", "lead_email", "lead_phone"];

export function trackEvent(eventName: string, params: Record<string, any> = {}) {
  if (typeof window === "undefined") return;

  // remove PII dos params que irão para GA/GTM
  const safe: Record<string, any> = {};
for (const [k, v] of Object.entries(params)) {
if (v !== undefined && v !== null) safe[k] = v;
}
PII_KEYS.forEach((k) => delete safe[k]);

  // 1) prioriza GTM
  if ((window as any).dataLayer && Array.isArray((window as any).dataLayer)) {
    (window as any).dataLayer.push({ event: eventName, ...safe });
    return;
  }

  // 2) fallback GA4 (gtag)
  if ((window as any).gtag) {
    (window as any).gtag("event", eventName, safe);
  }
}

export function formatSelectsEstados(value: Array<any>): any {
    // Converte a string de IDs priorizados para um array
    if(!value)
        return [];

    return value.map((v) => {
        if (v?.nome && v?.id) {
            return {
                label: `${v?.nome?.trim()} - ${v?.pais}`,
                value: v?.id
            };
        }
        return null;
    })
    .filter((v) => v)
}

export function formatSelects(value: Array<any>, cidade_priorizada?: String): any {
    // Converte a string de IDs priorizados para um array
    if(!value)
        return [];
    if(!cidade_priorizada || cidade_priorizada == '' || cidade_priorizada == undefined){
        return value.map((v) => {
            if (v?.nome && v?.id) {
                return {
                    label: v?.nome?.trim(),
                    value: v?.id,
                    id_estado: v?.id_estado ? v?.id_estado : 0,
                    imoveis: Number(v?.imoveis) || 0,
                };
            }
            return null;
        })
        .filter((v) => v);
    }

    // `.trim()` porque a configuração é digitada no CRM e costuma vir "35773, 35814".
    const idsPriorizados = cidade_priorizada
        ? cidade_priorizada.split(',').map((id) => id.trim()).filter(Boolean)
        : [];

    return value.map((v) => {
        if (v?.nome && v?.id) {
            return {
                label: v?.nome?.trim(),
                value: v?.id,
                id_estado: v?.id_estado ? v?.id_estado : 0,
                imoveis: Number(v?.imoveis) || 0,
            };
        }
        return null;
    })
    .filter((v) => v)
    .sort((a, b) => {
        // Verifica se os valores não são nulos
        if (a && b) {
            // Posição de cada uma na configuração (-1 = não priorizada)
            const posA = idsPriorizados.indexOf(a.value.toString());
            const posB = idsPriorizados.indexOf(b.value.toString());

            // As duas priorizadas: vale a ORDEM em que foram configuradas. Antes esse caso
            // devolvia 0 e sobrava a ordem alfabética da lista, então "35773,35814"
            // (Jundiaí, Itupeva) aparecia como Itupeva, Jundiaí — o inverso do configurado.
            if (posA !== -1 && posB !== -1) return posA - posB;
            if (posA !== -1) return -1;
            if (posB !== -1) return 1;
            return 0;
        }
        // Se um dos valores for nulo, mantenha a ordem original
        return 0;
    });
}

export function NumeroFormatado(numero: Number) {
    const numeroFormatado = numero.toLocaleString('pt-BR', { minimumFractionDigits: 2 , maximumFractionDigits: 2});
    return numeroFormatado;
}

export function cleanOrigin(url: string): string {
    const retorno = url.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
    return retorno.replaceAll('"',"")
}

export function formatSelectsTransacao(value: Array<any>): any {
    return value
        .map((v) => {
            if (v) {
                return {
                    label: v,
                    value: v,
                };
            }
            return null;
        })
        .filter((v) => v);
}

export function OnlyNumbersMask(initialValue: string): string {
    return (initialValue || '').replace(/\D/g, '');
}

export function BreakApart(itens: Array<any>, max: number): Array<any> {
    return itens.reduce((acumulador, item, indice) => {
        const grupo = Math.floor(indice / max);
        acumulador[grupo] = [...(acumulador[grupo] || []), item];
        return acumulador;
    }, []);
}

// #837: o interesse do lead nasce da transação do imóvel aberto (mesma regra do CRM
// legado — salvaLead.php/ficha-cliente.php derivam a transação do imóvel, nunca de um
// default fixo): só locação → 'Aluguel'; só venda → 'Venda'; ambos ou sem sinal →
// primeira transação do site (comportamento anterior, usuário escolhe).
export function interesseInicial(detailsProperties: any, site: any) {
    const venda = Number(detailsProperties?.venda) > 0 || detailsProperties?.venda === true;
    const aluguel = Number(detailsProperties?.aluguel) > 0 || detailsProperties?.aluguel === true;
    if (aluguel && !venda) return 'Aluguel';
    if (venda && !aluguel) return 'Venda';
    return site?.transacoes?.[0];
}
